import { render, staticRenderFns } from "./translates.vue?vue&type=template&id=255e29ca&"
import script from "./translates.vue?vue&type=script&lang=js&"
export * from "./translates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports